<template>
  <v-container fluid height="100%">
    <v-row v-if="error" align="center" justify="center" style="margin-top: 10%">
      <v-col class="text-center" cols="12">
        <h1 class="text-h3 font-weight-light mb-2">
          {{ $t(title) }}
        </h1>
        <h4 class="text-h5">{{ type }}</h4>
        <h4 class="text-h5">{{ description }}</h4>
        <v-progress-circular
          v-if="type == 'Utilisateur non cotisant'"
          :size="100"
          :width="8"
          style="margin-top: 8px"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-btn v-if="type != 'Utilisateur non cotisant'" elevation="2 mt-10" color="primary" @click="backHome" dark>
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('login.backHome') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else align="center" justify="center" style="margin-top: 15%">
      <v-col class="text-center" cols="12">
        <v-progress-circular :size="100" :width="8" color="primary" indeterminate> </v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'OidcCallback',
  data: () => ({
    error: false,
    title: "Erreur lors de l'authentification",
    type: '',
    description: '',
  }),
  computed: {
    ...mapGetters(['identity']),
  },
  methods: {
    ...mapMutations(['resetUser', 'resetState']),
    async initAxios(self) {
      // Add the bearer token to all outgoing requests
      await self.axios.interceptors.request.use(async (config) => {
        let idToken = await self.$authService.getIdToken();
        config.headers.common.Authorization = 'Bearer ' + idToken;
        return config;
      });
    },
    async backHome() {
      try {
        this.resetUser();
        this.resetState();
        window.localStorage.clear();
        this.$router.push('/');
        await this.$authService.removeUser();
      } catch (err) {
        console.error(err);
      }
    },
  },
  async mounted() {
    try {
      // Redirect callback
      await this.initAxios(this);
      const user = await this.$authService.getUserManager().signinRedirectCallback();
      try {
        if (['true', 'TRUE', 'True'].indexOf(user.profile.isCotisant) < 0 && user.profile.source != 'AzureAD') {
          this.$router.push('/logout');
        } else {
          if (this.$store.getters.url) {
            this.$router.push(this.$store.getters.url).catch(() => {});
          } else {
            this.$router.push('/').catch(() => {});
          }
          // USELESS ?
          // Get error
          var searchParams = new URLSearchParams(window.location.search);
          if (Array.from(searchParams.keys()).includes('error')) {
            this.error = true;
            if (searchParams.get('error_description')) {
              this.type = searchParams.get('error').replace('_', ' ');
              this.description = searchParams.get('error_description');
            }
          }
        }
      } catch (err) {
        this.$router.push('/logout');
        console.error(err);
      }
    } catch (err) {
      this.$router.push('/logout');
      console.error(err);
    }
  },
};
</script>
